import React from "react";
import { Modal, Button } from "@themesberg/react-bootstrap";
import "./index.module.css";

export const GlobalModal = ({
  isOpen,
  title = "Create Item",
  onClose,
  children,
}) => {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      className="custom-modal"
      size="xl"
      scrollable={true}
    >
      <Modal.Header>
        <Modal.Title className="h4">{title}</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={onClose} />
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};
